import React from 'react'
import Spinner from 'react-bootstrap/Spinner';


const ButtonSpinner = () => {
  return (
    <div>
        <Spinner size="sm" animation="border" variant="light" />
    </div>
  )
}

export default ButtonSpinner